import { ApiClient } from './api-client';
import type { ApiResponse } from '../types';

/** Mirrors the backend {@code NotificationType} enum. */
export type NotificationType =
  | 'MESSAGE'
  | 'PAYMENT'
  | 'CONTRIBUTION'
  | 'MEETING'
  | 'REMINDER'
  | 'SYSTEM'
  | 'SECURITY';

/** One in-app notification, as returned by the API and pushed over SSE. */
export interface AppNotification {
  id: string;
  /** A {@link NotificationType}; typed loosely so a future server-side
   *  value never breaks the client. */
  type: NotificationType | string;
  title: string;
  body: string;
  /** Optional deep-link target, e.g. 'CONVERSATION'. */
  referenceType: string | null;
  referenceId: string | null;
  read: boolean;
  createdAt: string;
}

export interface NotificationListQuery {
  unreadOnly?: boolean;
  page?: number;
  size?: number;
}

export const notificationsService = {
  list: (params: NotificationListQuery = {}): Promise<ApiResponse<AppNotification[]>> =>
    ApiClient.get<AppNotification[], NotificationListQuery>('/notifications', params),

  unreadCount: async (): Promise<number> =>
    (await ApiClient.get<{ count: number }>('/notifications/unread-count')).data.count,

  markRead: async (id: string): Promise<void> => {
    await ApiClient.post(`/notifications/${id}/read`);
  },

  markAllRead: async (): Promise<void> => {
    await ApiClient.post('/notifications/read-all');
  },
};
